import { apiCall, API, NEW_BE_API } from '../../utils/APIFunctions';

export function fetchObjectRights(params) {
  let hideExpired = "";
  if (params.opts?.hideExpired) {
    hideExpired = "&hideExpired=1";
  }

  return apiCall(`${API}/kp_objects/${params.objectId}/users?getCompanyRights=1${hideExpired}`, "GET");
}

export function newBEFetchObjectRights(params) {
  let hideExpired = "";
  if (params.opts?.hideExpired) {
    hideExpired = "&hideExpired=1";
  }

  return apiCall(`${NEW_BE_API}/api/n1/objects/${params.objectId}/users?getCompanyRights=1${hideExpired}`, "GET");
}

export function deleteObjectRight(params) {
  return apiCall(`${API}/kp_objects/${params.objectId}/users/${params.userId}`, "delete");
}

export function newBEDeleteObjectRight(params) {
  return apiCall(`${NEW_BE_API}/api/n1/objects/${params.objectId}/users/${params.userId}`, "delete");
}

export function saveObjectRights(params) {
  return apiCall(`${API}/kp_objects/${params.objectId}/users`, "post", JSON.stringify(params));
}

export function resendObjectRightsInvite(params) {
  return apiCall(`${NEW_BE_API}/api/n1/objects/${params.objectId}/users/${params.userId}/invite`, "post", JSON.stringify(params));
}

export function removeGroupFromObject(params) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/${params.groupId}/object/${params.objectId}`, "delete");
}

export function addGroupToObject(params) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/${params.groupId}/object/${params.objectId}`, "post",
    JSON.stringify({rightType: params.rightType, expiresTs: params.expiresTs})
  );
}

export function newBESaveObjectRights(params) {
  return apiCall(`${NEW_BE_API}/api/n1/objects/${params.objectId}/share`, "post", JSON.stringify(params));
} 